import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-index"},[_c('div',{staticStyle:{"margin":"auto"}},[_c(VBtn,{attrs:{"id":"bbb"},on:{"click":_vm.openNewWindos}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }